import Swiper from "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs";

// index.json (Landing Page for Pictureline Vendor Sliders)
new Swiper(".vendor-swiper", {
  // Optional parameters
  loop: true,
  autoplay: false,
  slidesPerView: 2,
  // If we need pagination
  pagination: {
    el: ".vendor-swiper-pagination",
  },

  breakpoints: {
    700: {
      slidesPerView: 3,
    },
    1000: {
      slidesPerView: 4,
    },
    1200: {
      slidesPerView: 5,
    },
  },
});

document.addEventListener("DOMContentLoaded", () => {
  new Swiper(".swiper", {
    slidesPerView: 1.5,
    spaceBetween: 0,
    autoplay: { delay: 5000 },
    pagination: { el: ".swiper-pagination", clickable: !0, dynamicBullets: !0 },
    breakpoints: {
      640: { slidesPerView: 2.25, spaceBetween: 0 },
      1024: { slidesPerView: 3.25, spaceBetween: 0 },
    },
  });
  new Swiper(".reviewsSwiper", {
    slidesPerView: 1.2,
    spaceBetween: 20,
    breakpoints: {
      640: { slidesPerView: 2.25 },
      1024: { slidesPerView: 3.25 },
    },
    pagination: { el: ".swiper-pagination-reviews" },
  });
  new Swiper(".ce-cards-lp-swiper", {
    slidesPerView: 1.2,
    spaceBetween: 20,
    breakpoints: { 640: { slidesPerView: 2.25 }, 1024: { slidesPerView: 4.1 } },
    pagination: {
      el: ".swiper-pagination-ce",
    },
  });
});
